module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/main__background@2x-5f1423f68743714e4f6968e43f6a194d.jpg";